import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import {
    CheckoutShoppingCart,
    CheckoutShoppingCartHTTPWrapper,
    Search,
    useSimpleInterface
} from '@klickly/front-packages';
import { inject, observer } from 'mobx-react';
import CashBackInfo from '../../shared/components/CashBackInfo';
import FavoritesPromotions from '../../shared/components/FavoritesPromotions';
import { FIELD_NAMES, GRID_POINTS, kcpAPI, PAGE_TYPES } from '../../shared/constants';
import { useRewardsModal } from '../../shared/hooks';
import { Layout } from '../ShopPage/components/Layout';
import { ButtonBadge } from './components/ButtonBadge';
import { useHandleGoToCheckout } from './hooks';
import { StyledFavoritesWrap } from './styles';

const ShoppingCartPage = inject('store')(
    observer(({ store }) => {
        const location = useLocation();
        const navigate = useNavigate();
        const navigationType = useNavigationType();
        const favoritesRef = useRef(null);
        const simple = useSimpleInterface(GRID_POINTS.md);
        const { setCashBackValue } = store.marketplaceStore;
        const { getShoppingCartState } = store.shoppingCartStore;
        const { pending, data: publisherInfo } = store.publisherStore;
        const handleCheckout = useHandleGoToCheckout(store);
        const { openRewardModal } = useRewardsModal();

        const handleOnRewardIconClick = ({ rewards }) => {
            return openRewardModal({
                rewards: rewards ?? []
            });
        };

        useEffect(() => {
            return () => {
                getShoppingCartState();
            };
        }, [getShoppingCartState]);

        useEffect(() => {
            store.favoritesPromotionsStore.getFavoritesPromotionsByStrategy();
        }, []);

        const onBackButtonClick = () => {
            navigate(-1);
        };

        return (
            <Layout
                header={!simple && <Search location={location} navigationType={navigationType} type='dp' />}
                withPadding={false}
                contentFullHeight
                cashbackInfo={
                    !pending &&
                    publisherInfo && (
                        <CashBackInfo
                            pageType={PAGE_TYPES.SHOPPING_CART}
                            badgeText={publisherInfo?.text?.topBanner[FIELD_NAMES.PDP]}
                            learnMoreText={publisherInfo?.text?.learnMore}
                            simple={simple}
                            publisherName={publisherInfo?.name}
                        />
                    )
                }
            >
                <CheckoutShoppingCartHTTPWrapper
                    links={{
                        cartFetch: kcpAPI.cart.get,
                        cartItemsManage: kcpAPI.cart.itemsManage,
                        buyNow: kcpAPI.cart.buyNow
                    }}
                    onCheckoutButtonClick={handleCheckout}
                    onBackButtonClick={navigationType === 'PUSH' ? onBackButtonClick : null}
                    onCashbackChange={setCashBackValue}
                    onRewardIconClick={handleOnRewardIconClick}
                >
                    <CheckoutShoppingCart
                        customizations={{
                            rootAppName: 'dp',
                            showProductPoints: false,
                            showApplyPointsBlock: false,
                            showRewards: true
                        }}
                        bottomExtraContent={
                            <StyledFavoritesWrap $simple={simple} ref={favoritesRef}>
                                <FavoritesPromotions
                                    promotions={store.favoritesPromotionsStore.favoritesPromotions}
                                    pending={store.favoritesPromotionsStore.pending}
                                />
                            </StyledFavoritesWrap>
                        }
                        buttonBadge={
                            <ButtonBadge
                                onClick={() => favoritesRef?.current?.scrollIntoView({ behavior: 'smooth' })}
                            />
                        }
                    />
                </CheckoutShoppingCartHTTPWrapper>
            </Layout>
        );
    })
);

export default ShoppingCartPage;
